/**
 * What operator-authored HTML may contain.
 *
 * One allowlist, held here because `@ibe/constants` has no dependencies and is
 * therefore the only package both a Fastify service and a browser bundle can
 * import. The server sanitises on write with `sanitize-html` and the browser
 * sanitises on render with DOMPurify; two engines reading two lists would
 * eventually disagree, and the disagreement would be a tag that survives the
 * write and is stripped on render — a policy that saves and displays as blank.
 *
 * The list is deliberately small. A policy document is prose, a heading, a
 * list and occasionally a table. Nothing here can load a resource, run a
 * script, or position an element over another one.
 */
/** Tags that survive sanitisation. Everything else is unwrapped or dropped. */
export const RICH_TEXT_ALLOWED_TAGS = [
    'p',
    'br',
    'h2',
    'h3',
    'h4',
    'ul',
    'ol',
    'li',
    'strong',
    'em',
    'u',
    's',
    'a',
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td',
];
/**
 * Attributes that survive, per tag.
 *
 * No `style`, no `class`, no `id`. A policy that carries its own styling
 * fights the page it is rendered into, and `style` is enough on its own to
 * cover the booking form with an invisible overlay.
 */
export const RICH_TEXT_ALLOWED_ATTRIBUTES = {
    a: ['href', 'title', 'target', 'rel'],
    th: ['colspan', 'rowspan'],
    td: ['colspan', 'rowspan'],
};
/**
 * URL schemes a link may use.
 *
 * `javascript:` is absent, which is the point — it is the shortest path from
 * an operator-authored document to script running in a guest's session.
 */
export const RICH_TEXT_ALLOWED_SCHEMES = ['http', 'https', 'mailto', 'tel'];
/**
 * The longest document that may be stored, in characters.
 *
 * Matches the check constraint in `0029_policy_crud.sql`. Enforced in the
 * schema as well so an over-long document is a sentence beside the editor
 * rather than a 500 from the driver.
 */
export const MAX_RICH_TEXT_LENGTH = 65536;
//# sourceMappingURL=rich-text.js.map